var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgVideoPlayer = function SvgVideoPlayer(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20,
    height: 20,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#748DA9",
    d: "M2.5 3.328c0-.457.37-.828.828-.828h13.345c.456 0 .827.37.827.828v13.345a.83.83 0 0 1-.828.827H3.329a.83.83 0 0 1-.828-.828zm1.667.839v11.666h11.666V4.167zm4.685 2.846 4.066 2.71a.334.334 0 0 1 0 .554l-4.067 2.71a.333.333 0 0 1-.518-.276V7.289a.333.333 0 0 1 .519-.276"
  })));
};
export default SvgVideoPlayer;